// src/Modules/Log/Data/repositories/LogRepositoryImpl.ts
import { AxiosResponse } from 'axios';
import { GetLogsResponse, Log, LogPagination, LogSummary } from '../../Model/Log';
import {
  LogParams,
  LogRepository,
} from '../../Domain/Repositories/LogRepository';
import { api } from '../../../../api/axiosInstance';

type LogsApiResponse =
  | Log[]
  | {
      count: number;
      total_pages: number;
      current_page: number;
      page_size: number;
      results: Log[];
    };

export class LogRepositoryImpl implements LogRepository {
  private http = api;

  private normalizeParams(params: LogParams = {}) {
    const normalizedParams = {
      ...params,
      action: Array.isArray(params.action) ? params.action.join(',') : params.action,
      page_size: params.page_size ?? params.pageSize,
    };

    delete normalizedParams.pageSize;
    return normalizedParams;
  }

  getLogs(params: LogParams = {}) {
    const normalizedParams = this.normalizeParams(params);

    return this.http
      .get<LogsApiResponse>('/logs/', { params: normalizedParams })
      .then((r: AxiosResponse<LogsApiResponse>) => {
        const data = r.data;

        if (Array.isArray(data)) {
          return { results: data } satisfies GetLogsResponse;
        }

        const pagination: LogPagination = {
          current_page: data.current_page,
          page_size: data.page_size,
          total_count: data.count,
          total_pages: data.total_pages,
        };

        return {
          results: data.results ?? [],
          pagination,
        } satisfies GetLogsResponse;
      });
  }

  getSummary(params: LogParams = {}) {
    const normalizedParams = this.normalizeParams(params);
    delete normalizedParams.page;
    delete normalizedParams.page_size;

    return this.http
      .get<LogSummary>('/logs/summary/', { params: normalizedParams })
      .then((r: AxiosResponse<LogSummary>) => r.data);
  }

  deleteLog(logId: number): Promise<void> {
    return this.http
      .delete(`/logs/${logId}/delete_log/`)
      .then(() => {});
  }


  bulkDeleteLogs(logIds: number[]): Promise<void> {
    return this.http
      .post('/logs/bulk_delete/', { log_ids: logIds })
      .then(() => {});
  }
}
